export const ContentContainer = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  rowGap: "20px",
}

export const ItemContainer = {
  display: "flex",
  overflowWrap: "anywhere",
  justifyContent: "space-between",
  alignItems: "center",
}
export const InitialsContainer = {
  display: "flex",
  flexDirection: "row",
  columnGap: "14px",
  alignItems: "center",
}
